import React from 'react';
import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import ImgNotFound from 'src/assets/images/tipo_notfound.svg';

const Wrapper = styled.div`
  text-align: center;
  padding: 100px 50px;
`;
const Img = styled.img`
  height: 300px;
`;
const Text = styled.div`
  font-size: 18px;
  color: ${colors.BlueGray_600};
`;

const NotFoundPage: React.FC = () => {
  const text = '查無相關資訊，請重新輸入查詢條件項目。';
  return (
    <Wrapper>
      <Img src={ImgNotFound} alt="Image Not Found" />
      <Text>{text}</Text>
    </Wrapper>
  );
};

export default NotFoundPage;
